import { Component } from "preact";
import { isNullOrUndefined } from "util";
import { isNumber, numberWithCommas, numberWithoutCommas, getCurrencySymbol } from "../../../../utils/utility";
import { preventDefault, validateAmountWeb, showRupee } from "../../../../utils/common";
import { logEvent } from "../../../../utils/logger";
import style from "./style";

export default class AmountInput extends Component {
  constructor(props) {
    super(props);
    this.state = { isError: false, errorName: "", inputValue: "", showRupeeInAmount: false };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isError !== this.props.isError || nextProps.errorName !== this.props.errorName) {
      this.setState({ isError: nextProps.isError, errorName: nextProps.errorName });
    }
  }

  validateNumberInput = event => {
    if (!isNumber(event)) {
      preventDefault(event);
    }
  };

  updateValue = amt => {
    this.props.updateFormValue(this.props.index, numberWithoutCommas(amt));
  };

  clearErrors = () => {
    if (this.state.isError && !isNullOrUndefined(this.props.index)) {
      this.props.clearErrorData(this.props.index);
    }
    logEvent({ eventType: "clicked_form_field", eventValue: "amount form field", fieldName: this.props.name });
  };

  shouldComponentUpdate(nextProps) {
    if (
      nextProps.inputValue == this.props.inputValue &&
      nextProps.isError == this.props.isError &&
      nextProps.errorName == this.props.errorName
    ) {
      return false;
    }
  }

  validateWebAmount = event => {
    if (validateAmountWeb(event)) {
    } else {
      return preventDefault(event);
    }
  };

  setAmountField = event => {
    if (event && event.target) {
      let showRs = showRupee(event, false);
      const amt = numberWithCommas(event.target.value);
      if (amt === "") {
        showRs = showRupee(event, false);
      }
      this.setState({ showRupeeInAmount: showRs, inputValue: amt });
      this.updateValue(amt);
    }
  };

  pasteNumber = event => {
    setTimeout(() => {
      if (event && event.target) {
        const number = event.target.value;
        if (isNumber(number)) {
          this.setAmountField(event);
        } else {
          event.target.value = "";
        }
      }
    }, 0);
  };

  // onPaste={this.pasteNumber}
  render({ name, constraints, placeholder, subText }) {
    const maxLength = constraints.maxLength ? constraints.maxLength : "";
    return (
      <div className={style["pos-r"]}>
        {this.state.showRupeeInAmount && (
          <span id="rupee" className={`${style["rupee-sign"]}`}>
            {getCurrencySymbol()}
          </span>
        )}
        <input
          name={name}
          type="text"
          inputmode="numeric"
          value={this.state.inputValue}
          placeholder={placeholder}
          maxlength={maxLength}
          onKeyDown={this.validateWebAmount}
          onKeyUp={this.setAmountField}
          onFocus={this.clearErrors}
          className={this.state.showRupeeInAmount ? style["has-val"] : ""}
          onPaste={this.pasteNumber}
          autocomplete="off"
        />
        {subText && <p className="input-info">{subText}</p>}
        {this.state.isError && (
          <span className={`error ${subText ? "sub-txt-err" : ""}`} data-error-for={name}>
            {this.state.errorName}
          </span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/inputs/user-amount/index.js